import script from "./LiveFixtureDoubleMarketOverviewOdd.vue?vue&type=script&setup=true&lang=js"
export * from "./LiveFixtureDoubleMarketOverviewOdd.vue?vue&type=script&setup=true&lang=js"

import "./LiveFixtureDoubleMarketOverviewOdd.vue?vue&type=style&index=0&id=30f6d372&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30f6d372"]])

export default __exports__